export default __webpack_public_path__ + "9e445a4bcfb258336a04fceefe8d2c76ef31d898c844ccddc6ddd3cbb880c018.svg";